/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

import { CategoryCard } from '../../CompanyEvents/EventLibrary/style';
import { EventPointsWrapper } from '../../MainEvents/styles';
import LazyImage from '../LazyImage/LazyImage';
import { ImageUrl } from '../../../utils/constants';

const InitiativeCategoryGrid = ({ categories, onCategoryClick }) => {
  if (!categories?.length) return null;

  return (
    <EventPointsWrapper margin gap={"12px"}>
      {categories.map((category, index) => {
        const bgColor     = category?.background_color || "#F2F5FB";
        const borderColor = category?.border_color     || "#DCDCDC";

        return (
          <CategoryCard
            key={index}
            style={{ border: `0.75px solid #DCDCDC`, width: "calc((100% - 24px) / 3)" }}
            isCardRadius={"12px"}
            isBorderRadius={"4px"}
            cardHeight={"72px"}
            cardPadding={"12px 8px"}
            background={bgColor}
            onClick={() => onCategoryClick && onCategoryClick(category)}
          >
            <div className="icon" style={{ border: `1px solid ${borderColor}` }}>
              <LazyImage src={ImageUrl + "/" + category?.icon} alt={category?.category_name || category?.name} />
            </div>
            <div className="name" title={t(category?.category_name || category?.name)}>
              {t(category?.category_name || category?.name)}
            </div>
          </CategoryCard>
        );
      })}
    </EventPointsWrapper>
  );
};

InitiativeCategoryGrid.defaultProps = {
  onCategoryClick: null,
};

InitiativeCategoryGrid.propTypes = {
  categories:      PropTypes.array.isRequired,
  onCategoryClick: PropTypes.func,
};

export default withTranslation()(InitiativeCategoryGrid);
